<app-student-module ModuleName='Running Record' [NewHidden]="false" (New)="newRecord(content)" [PrintOptions]="printOptions">
  <sortable-table [data]="evidence" [headers]="headers" [showDelete]="true" (delCall)="del($event)"
                  (editCall)="edit($event, content)"
                  [showEdit]="true" defaultSort="date"></sortable-table>
</app-student-module>


<ng-template #content let-modal>
  <form #form="ngForm" (submit)="save(evidenceModal, form)">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!evidenceModal.id">Add Running Record</h4>
      <h4 class="modal-title" id="modal-basic-title" *ngIf="evidenceModal.id">Edit Running Record</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="date" class="required-field">Date</label>
        <input type="date" class="form-control" id="date" name="date" [(ngModel)]="evidenceModal.date" required
               #date="ngModel" [max]="maxDate">
        <ng-container *ngIf="date.touched && date.errors">
          <span *ngIf="date.errors['required']" class="text-danger">You must provide a date for the record</span>
          <span *ngIf="date.errors['max']" class="text-danger">You cannot provide a date in the future</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="concern" class="required-field">Concern</label>
        <textarea #concern="ngModel" class="form-control" minlength="10" maxlength="2500" id="concern" name="concern"
                  [(ngModel)]="evidenceModal.concern" rows="5" cols="20"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ evidenceModal.concern?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="concern.touched && concern.errors">
          <span *ngIf="concern.errors['required']" class="text-danger">You must provide one ore more concerns for the record</span>
          <span *ngIf="concern.errors['minlength']" class="text-danger">Concern must be at least 10 characters</span>
          <span *ngIf="concern.errors['maxlength']"
                class="text-danger">Concern must be less than 2500 characters</span>
        </ng-container>
      </div>
      <div class="form-group">
        <label for="evidence" class="required-field">Evidence</label>
        <textarea #evidence="ngModel" class="form-control" minlength="10" maxlength="2500" id="evidence" name="evidence"
                  [(ngModel)]="evidenceModal.evidence" rows="5" cols="20"></textarea>
        <div class="d-flex">
          <span class="ms-auto me-3 text-secondary">{{ evidenceModal.evidence?.length || 0 }} / 2500</span>
        </div>
        <ng-container *ngIf="evidence.touched && evidence.errors">
          <span *ngIf="evidence.errors['required']" class="text-danger">You must provide evidence for the concern</span>
          <span *ngIf="evidence.errors['minlength']" class="text-danger">Evidence must be at least 10 characters</span>
          <span *ngIf="evidence.errors['maxlength']"
                class="text-danger">Evidence must be less than 2500 characters</span>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <div class="form-check me-auto" *ngIf="!evidenceModal.id">
      <input type="checkbox" class="form-check-input" id="add_more" [(ngModel)]="keepModalOpen">
      <label class="form-check-label" for="add_more">Add another record</label>
    </div>
    <button class="btn btn-success" type="button" (click)="save(evidenceModal, form)"
            [disabled]="form.untouched || form.invalid">
      <span class="fa fa-save" aria-hidden="true">&nbsp;</span> Save
    </button>
    <button class="btn btn-warning" aria-label="Cancel" (click)="modal.dismiss('cancel')">
      Cancel
    </button>
  </div>
</ng-template>
